

export  const langData = ['EN','PL','UA','RU'];